import { t } from '@lingui/macro';
import { Alert } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
export function LoadErrorAlert() {
    return (<Alert appearance="danger" icon={<Falcon icon="info-circle"/>} message={t({
            message: 'Something went wrong, please try again later',
            comment: 'Error message for not being able to load external sharing section',
        })}/>);
}
